import { Typography } from "@/components/Typography"
import Platforms from "./Platforms"
import type { StarInfoResponse } from "@/service/api/info"

interface Props {
  starInfo?: StarInfoResponse
}

const Bottom = ({ starInfo }: Props) => {
  const { youtubeUrl, instargramUrl, facebookUrl, angkorlifeUrl } =
    starInfo ?? {}

  return (
    <div className="border-t border-Divider">
      <div className="flex items-center justify-center gap-3 mt-5 h-14">
        {youtubeUrl && <Platforms title="youtube" linked={youtubeUrl} />}
        {instargramUrl && (
          <Platforms title="instagram" linked={instargramUrl} />
        )}
        {facebookUrl && <Platforms title="facebook" linked={facebookUrl} />}
        {angkorlifeUrl && (
          <Platforms title="angkorlife" linked={angkorlifeUrl} />
        )}
      </div>

      <div className="pb-25">
        <Typography
          variant="regular"
          className="text-[12px] leading-4 font-normal tracking-normal text-center align-bottom text-label-secondary"
        >
          Copyright ©AngkorLife
        </Typography>
        <Typography
          variant="regular"
          className="text-[12px] leading-4 font-normal tracking-normal text-center align-bottom text-label-secondary"
        >
          Provided by K've Entertainment
        </Typography>
      </div>
    </div>
  )
}

export default Bottom
